export function isAuthRequired(url) {
  const urlParts = url.split("/").map((part) => part.split("?"));
  var urls = [].concat(...urlParts);

  return (urls.includes("user") || urls.includes("product") || urls.includes("auth")) 
}